import React from "react";
import { Navigate } from "react-router-dom";

import { ErrorBoundary } from "./ErrorBoundary";

export const ProtectedRoute = ({ children }) => {
  return children ? <ErrorBoundary>{children}</ErrorBoundary> : <Navigate to="/" replace />;
};
